import EnterpriseSSOExperiments from 'bundles/epic/clients/EnterpriseSSO';

export const isForcedSSOLoginFlowEnabled = () => EnterpriseSSOExperiments.get('enableForceSsoLoginV2Beta');
